export const style = {
  p: {
    fontSize: `14px`,
    fontWeight: 400,
    padding: `10px 0`,
    margin: `0 0 20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/paragraphs.js